// extracted by mini-css-extract-plugin
export default {"overlay":"LoadingOverlay_overlay__7ARPG","show":"LoadingOverlay_show__Tx+Jv","text":"LoadingOverlay_text__uFu+G"};